import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import { useAuth } from '../context/AuthContext';
import { HISTORY_IMAGES, historyImageSrc } from '../lib/historyImages';
import { renderInlineBold } from '../lib/renderInlineBold';

const HistoryPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [historyText, setHistoryText] = useState('');
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    let active = true;
    async function loadHistory() {
      try {
        const response = await fetch('/legacy/history.md');
        if (!response.ok) throw new Error('Unable to load history.');
        const text = await response.text();
        if (!active) return;
        setHistoryText(text);
      } catch (_err) {
        if (!active) return;
        setLoadError('History content is temporarily unavailable.');
      }
    }
    loadHistory();
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="page-shell">
      <TopBar chip="History">
        <Button variant="outline-secondary" size="sm" onClick={() => navigate(isAuthenticated ? '/lobby' : '/login')}>
          ← Back
        </Button>
      </TopBar>

      <section className="lobby-hero">
        <h1>Where Numerica Came From</h1>
        <p>The story of the game, with photographs of original sets.</p>
      </section>

      <div className="surface-panel p-3 p-md-4">
        <h2 className="panel-title">
          Historical Background <small>Archive</small>
        </h2>
        {loadError && <p className="text-danger">{loadError}</p>}
        {!loadError && !historyText && <p className="muted-text">Loading history…</p>}
        {historyText && <div className="document-body mb-3">{renderInlineBold(historyText)}</div>}

        <div className="history-image-grid">
          {HISTORY_IMAGES.map((filename, index) => (
            <img key={filename} src={historyImageSrc(filename)} alt={`Numerica history reference ${index + 1}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HistoryPage;
